/**
 * Clears checkout session data from localStorage.
 * Removes lastActiveStep, lastActiveTime, lastCheckoutCartId, and payment-details.
 *
 * @returns {void}
 */
export const clearCheckoutSession = () => {
    localStorage.removeItem('lastActiveStep');
    localStorage.removeItem('lastActiveTime');
    localStorage.removeItem('lastCheckoutCartId');
    localStorage.removeItem('payment-details');
};
